<div class="checkbox-cnt">
    <mat-checkbox [(ngModel)]="checked" (change)="onTermsAccepted()" id="termsCheckbox">
    </mat-checkbox>
    <label for="termsCheckbox" class="small-text">
      He leído y acepto la <a [href]="privacyUrl" target="_blank">política de privacidad</a> y los 
      <a [href]="termsUrl" target="_blank">términos y condiciones</a>.
    </label>
  </div>
  